<template>
  <div>
    <OJumbo v-if="row == null" spin>
      Carregando...
    </OJumbo>

    <div v-else>
      <v-toolbar
        color="#f5f5f5"
        class="elevation-0 mb-0"
        style="position: relative; border-bottom: 1px solid #ccc"
      >
        <v-btn icon class="ml-0" @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-toolbar-title class="ml-3 px-0" style="min-width: 350px">
          {{ shortName }}
        </v-toolbar-title>

        <div class="grow-1 shrink-1">
          <OTabs v-model="currentTab" :tabs="availableTabs" />
        </div>

        <v-btn
          icon
          active-class="not-really-active"
          :to="`/setup/technicians/${row.id}`"
          target="_blank"
          class="mx-0"
        >
          <v-icon>mdi-open-in-new</v-icon>
        </v-btn>
      </v-toolbar>

      <OLoadingLine absolute :value="isLoading" />

      <v-tabs-items v-model="currentTab">
        <v-tab-item value="overview">
          <ORow top class="pa-3 children-ma-3">
            <div class="oderon-col-4">
              <Overview :row="row" @reload="reload" />
            </div>
            <div class="oderon-col-4">
              <Cards :row="row" @reload="reload" />
            </div>
            <div class="oderon-col-4">
              <Orgs :row="row" @reload="reload" />
            </div>
          </ORow>
        </v-tab-item>

        <v-tab-item value="history">
          <History :row="row" />
        </v-tab-item>

        <v-tab-item value="depot">
          <Depot :row="row" />
        </v-tab-item>

        <v-tab-item value="values">
          <Values :row="row" />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import { Technician, minMs3 } from '@/models'
import Overview from './Overview.vue'
import Cards from './Cards.vue'
import Orgs from './Orgs.vue'
import History from './History.vue'
import Depot from './Depot.vue'
import Values from './Values.vue'

export default {
  components: { Overview, Cards, Orgs, History, Depot, Values },
  data() {
    return {
      isLoading: false,
      row: null,
      currentTab: 'overview'
    }
  },
  props: {
    techId: { type: Number, required: true }
  },
  computed: {
    availableTabs() {
      let result = [
        { value: 'overview', label: 'Geral' },
        { value: 'history', label: 'Histórico' },
        { value: 'depot', label: 'Estoque' },
        { value: 'values', label: 'Valores' }
      ]
      return result
    },

    shortName() {
      if (this.row == null) return null
      return this.row.name.replace(/Autorizado Oderon/, 'Aut.Od.')
    }
  },
  mounted() {
    this.reload()
  },
  watch: {
    techId() {
      this.reload()
    }
  },
  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },

    async fetchData() {
      this.row = await minMs3(Technician.findById(this.techId))
    }
  }
}
</script>

<style></style>
